import React from 'react';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-20">
        <Gallery />
      </div>
    </div>
  );
};

export default GalleryPage;
